import { useEffect, useState, useRef } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import commonUtil from "../../../common/commonUtil";
import messageConst from "../../../const/messageConst";
import { GetPublicHoliday } from "../../../hooks/getPublicHoliday";
import { getGradeListParam } from "../../../pages_membership_hotel/hotel/membershipVacancy";
import "../../../resources/css/common/calendar.css";
import cross from '../../../resources/icons/ico_X.svg';
import circle from '../../../resources_membership_hotel/icons/ico_circle.svg';
import minus from '../../../resources_membership_hotel/icons/ico_minus.svg';
import slash from '../../../resources_membership_hotel/icons/ico_slash.svg';
import square from '../../../resources_membership_hotel/icons/ico_square.svg';
import triangle from '../../../resources_membership_hotel/icons/ico_triangle.svg';
import { Image } from "../../atoms/image";
import { Label } from '../../atoms/label';
import { ModalClose } from "../../atoms/modalClose";
import { PrivilegeIcon } from "../../atoms/privilegeIcon";
import './../../../resources_membership_hotel/css/popup/facility_calendar_popup.css';

// 空室照会の検索結果の施設名を押下した時のカレンダ
const FacilityVacancyCalendarContainer = (props) => {
    const { state,
        room,
        resvKaiinken,
        grade,
        setMembershipSearchParam,
        onClickCalendarMove,
        membershipFacility,
        setMembershipFacility,
        setDispFacility,
        setCheckIn,
        setCheckOut,
        // vacancyItems,
        adultNum,
        childNum,
        toHotelSearchView,
        onClickCloseFacilityCalendarWindow } = props;

    // 祝日取得用カスタムフック
    const { getHoliday } = GetPublicHoliday();

    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [selectDate1, setSelectDate] = useState("");
    const [activeStartDate, setActiveStartDate] = useState(null);
    const maxDate = useRef(null);
    const minDate = useRef(null);
    const firstDate = useRef(null);
    const count = useRef(0);
    const popupFlg = state.facilityCalendarPopup;
    const calendarStartDate = state.calendarStartDate;
    const facilityId = state.facilityId;
    // const dataList = state.vacancyItems;
    const facilityTel = state.facilityTel;
    const store = useStore();
    const history = useHistory();
    const [latestFlg, setLatestFlg] = useState(false);
    // 変更するとnextDate()を呼ぶカウンタ
    const [callNextCount, setCallNextCount] = useState(0);
    // 変更するとprevDate()を呼ぶカウンタ
    const [callPrevCount, setCallPrevCount] = useState(0);


    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    // プレー日欄に表示する日付取得(初回レンダリング時)
    useEffect(() => {
        if (popupFlg) {
            document.getElementById("calendarDecision").disabled = false;
        }

        // カレンダー表示起点日
        let startDate = new Date();

        let selectDate = calendarStartDate || new Date();
        selectDate.setDate(selectDate.getDate() + 3);
        setSelectDate(selectDate);

        //storeにdateが入っていればそちらを使う
        if (store.getState().checkIn) {
            let checkIn = new Date(store.getState().checkIn);
            setSelectDate(checkIn);
            startDate = checkIn;
            // カレンダー選択項目
            setActiveStartDate(checkIn);
        } else {
            setSelectDate(selectDate);
            // カレンダー選択項目
            setActiveStartDate(selectDate);
        }

        let now = new Date();
        let d1Month = startDate.getFullYear() * 12 + startDate.getMonth();
        let d2Month = now.getFullYear() * 12 + now.getMonth();
        let diffMonth = d1Month - d2Month;
        count.current = diffMonth;

        // カレンダー最大選択範囲
        let max = new Date();
        max.setFullYear(max.getFullYear() + 1);
        maxDate.current = max;

        // カレンダー最小選択範囲
        minDate.current = new Date();

        let first = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        firstDate.current = first;
    }, [popupFlg]);

    useEffect(() => {
        // 次へ表示ボタンに関数登録
        const nextElm = document.getElementsByClassName("react-calendar__navigation__arrow react-calendar__navigation__next-button");
        // nextElm[1].addEventListener("click", nextDate);
        // remove しないとたまっていくから１回しかよべない
        // 最新のnextDate()を呼ぶため、ここではカウンタをインクリメントし、カウンタをdepsにしたuseEffectにてnextDate()を呼びだす方式
        nextElm[1].addEventListener("click", () => {setCallNextCount(prevState=> prevState + 1)});

        // 戻る表示ボタンに関数登録
        const prevElm = document.getElementsByClassName("react-calendar__navigation__arrow react-calendar__navigation__prev-button");
        // prevElm[1].addEventListener("click", prevDate);
        prevElm[1].addEventListener("click", () => {setCallPrevCount(prevState=> prevState + 1)});

    }, []);
    useEffect(() => {
        // 初期表示以外で呼ぶ
        if (callNextCount > 0) {
            nextDate();
        }
    }, [callNextCount]);
    useEffect(() => {
        if (callPrevCount > 0) {
            prevDate();
        }
    }, [callPrevCount]);

    // 次へ表示制御
    const nextDate = () => {
        const activeDate = new Date();
        activeDate.setDate(1);
        count.current += 1;
        activeDate.setMonth(activeDate.getMonth() + count.current);
        setActiveStartDate(activeDate);

        const start = new Date();
        start.setDate(25);
        start.setMonth(start.getMonth() + count.current - 1);


        let riyoDateFrom;
        const current = firstDate.current
        if (current >= start) {
            riyoDateFrom = commonUtil.getStringFromDate(new Date(current), "yyyy-MM-dd");
        } else {
            riyoDateFrom = commonUtil.getStringFromDate(new Date(start), "yyyy-MM-dd");
        }

        const end = new Date(activeDate);
        end.setMonth(end.getMonth() + 1);
        end.setDate(6);
        let riyoDateTo;
        if (end < maxDate.current) {
            riyoDateTo = commonUtil.getStringFromDate(end, "yyyy-MM-dd");
        } else {
            riyoDateTo = commonUtil.getStringFromDate(maxDate.current, "yyyy-MM-dd");
        }
        // const shisetsuCd = store.getState().vacancyFacility.filter(data => {
        //     return data.selected
        // })[0].shisetsuCd

        // const shisetsuCdList = shisetsuCd ? [shisetsuCd] : null

        const shisetsuCdList = [facilityId];

        // const grade = store.getState().gradeData.filter(data => {
        //     return data.selected
        // })[0].grade
        // const roomGradeList = grade ? [grade] : null
        const roomGradeList = getGradeListParam(store.getState().gradeData);

        const param = {
            shisetsuCdList,
            roomGradeList,
            riyoDateFrom,
            riyoDateTo
        }
        onClickCalendarMove(param);
    }

    // 戻る表示制御
    const prevDate = () => {
        const activeDate = new Date();
        activeDate.setDate(1);
        count.current -= 1;
        if (count.current < 0) {
            count.current = 0;
            return;
        }
        activeDate.setMonth(activeDate.getMonth() + count.current);
        setActiveStartDate(activeDate);

        const start = new Date();
        start.setDate(25);
        start.setMonth(start.getMonth() + count.current - 1);

        let riyoDateFrom;
        const current = firstDate.current
        if (current >= start) {
            riyoDateFrom = commonUtil.getStringFromDate(new Date(current), "yyyy-MM-dd");
        } else {
            riyoDateFrom = commonUtil.getStringFromDate(new Date(start), "yyyy-MM-dd");
        }

        const end = new Date(activeDate);
        end.setMonth(end.getMonth() + 1);
        end.setDate(6);
        const riyoDateTo = commonUtil.getStringFromDate(end, "yyyy-MM-dd");
        // const shisetsuCd = store.getState().vacancyFacility.filter(data => {
        //     return data.selected
        // })[0].shisetsuCd
        // const shisetsuCdList = shisetsuCd ? [shisetsuCd] : null
        const shisetsuCdList = [facilityId];
        // const grade = store.getState().gradeData.filter(data => {
        //     return data.selected
        // })[0].grade
        // const roomGradeList = grade ? [grade] : null
        const roomGradeList = getGradeListParam(store.getState().gradeData);

        const param = {
            shisetsuCdList,
            roomGradeList,
            riyoDateFrom,
            riyoDateTo
        }
        onClickCalendarMove(param);
    }

    // 表示する日付取得
    const onClickTargetDay = (val, event) => {
        // 「満室」「クローズ」「予約受付対象外」は遷移させない
        if (!state.vacancyItems) return
        const targetDate = commonUtil.getStringFromDate(new Date(val), "yyyy-MM-dd");
        const vacancyMark = state.vacancyItems.find(value => {
          if (commonUtil.getStringFromDate(new Date(value.riyoDate), "yyyy-MM-dd") === targetDate) {
            return value.kushitsuMark
          }
        }).kushitsuMark
        if (vacancyMark === "×" || vacancyMark === "－" || vacancyMark === "／") {
          return
        }
        const checkInDate = new Date(val);
        const startDate = commonUtil.getStringFromDate(checkInDate, "yyyy-MM-dd");
        const checkOutDate = new Date(val)
        checkOutDate.setDate(checkOutDate.getDate() + 1)
        const today = commonUtil.getStringFromDate(new Date(), "yyyy-MM-dd");
        const within3 = commonUtil.getNights(today, startDate, "-");
        if (within3 < 3) {
            setLatestFlg(true);
        } else {
            setLatestFlg(false);
            toHotelSearchView(store, history, facilityId, checkInDate)
            // setCheckIn(checkInDate);
            // setCheckOut(checkOutDate)
            // // 選択項目の移動
            // setSelectDate(val);
            // const login = store.getState().login;
            // if (!login && login.apiKey === null) {
            //     store.dispatch({ type: "CLEAR_STATE" });
            //     history.push("/reserve/login");
            // }
            // history.push('/reserve/hotel/search', { prevRef: 'vacancy' })
            // // history.push("/reserve/hotel/search")
        }
    };

    // カレンダーの月表示を大きくするための関数
    const layoutChangeOfMonth = (date) => {

        const from = document.getElementsByClassName("react-calendar__navigation__label__labelText--from")[1];
        const to = document.getElementsByClassName("react-calendar__navigation__label__labelText--to")[1];
        const y = date.getFullYear();
        const m = date.getMonth() + 1;

        if (from && to) {

            if (!from.getAttribute("data-flg")) {
                from.innerHTML = `${y}年<spna class='month-view'> ${m}月</span>`;
                from.setAttribute("data-flg", "on");
            } else {
                to.innerHTML = `${y}年<spna class='month-view'> ${m}月</span>`;
                from.removeAttribute("data-flg");
            }
        }
    };

    // カレンダーの月表示を大きくするための関数(スマホ版)
    const layoutChangeOfMonthMobile = (date) => {

        const label = document.getElementsByClassName("react-calendar__navigation__label__labelText--from")[1];
        const checkIn = activeStartDate || new Date();

        const y = checkIn.getFullYear();
        const m = checkIn.getMonth() + 1;

        if (label) {
            label.style.width = "100%";
            label.style.padding = "0";
            label.innerHTML = `${y}年<spna class='month-view'> ${m}月</span>`;
        }
    };

    // 決定ボタン押下時
    const decision = () => {
        // 二度押し防止
        document.getElementById("calendarDecision").disabled = true;
    };

    const onClickClose = () => {
        // ポップアップの表示・非表示用更新関数
        onClickCloseFacilityCalendarWindow();
    }

    //日付の内容を出力
    const getTileContent = (calendar) => {

        // 日付フォーマット処理
        const targetDate = commonUtil.getStringFromDate(new Date(calendar.date), "yyyy-MM-dd");
        // タイルに表示する内容の初期化
        let vacancy = "";
        if (state.vacancyItems) {
            state.vacancyItems.forEach(value => {
                if (commonUtil.getStringFromDate(new Date(value.riyoDate), "yyyy-MM-dd") == targetDate) {
                    vacancy = value.kushitsuMark;
                }
            })
        }

        // タイルに表示する内容を返却
        return (
            <div style={{ height: "30%" }}>
                <Label
                    style={
                        vacancy === "○" ? (
                            style.circle
                        ) : (vacancy === "△" ? (
                            style.triangle
                        ) : (vacancy === "□" ? (
                            style.square
                        ) : (vacancy === "×" ? (
                            style.cross
                        ) : (vacancy === "－" ? (
                            style.minus
                        ) : (vacancy === "／" ? (
                            style.slash
                        ) : (
                            style.occupy
                        ))))))
                    }
                    label={vacancy === "占" ? "占" : ""}
                />
            </div>
        );
    }

    const getbackGroundColor = (activeStartDate, date, view) => {

        // 日付フォーマット処理
        const targetDate = commonUtil.getStringFromDate(new Date(date), "yyyy-MM-dd");
        // タイルに表示する内容の初期化
        let vacancy = "";
        let right = "";
        if (state.vacancyItems) {
            state.vacancyItems.forEach(value => {
                if (commonUtil.getStringFromDate(new Date(value.riyoDate), "yyyy-MM-dd") == targetDate) {
                    vacancy = value.kushitsuMark;
                    right = value.iroKbn;
                }
            })
        }

        // タイル背景を返却
        let backGroundColor = "";
        backGroundColor = vacancy === "○" || vacancy === "△" || vacancy === "□" || vacancy === "占" ?
            (right == "gold" ? "right_gold"
                : (right == "red" ? "right_red"
                    : (right == "white" ? "right_white"
                        : "right_blue")))
            : "right_none";
        return (getHoliday(activeStartDate, date, view) + " " + backGroundColor);
    }

    const closeLatestModal = () => {
        setLatestFlg(false);
    }

    return (
        <>
            <div className={popupFlg ? "popupIsShow" : "popup"} id="js-popup">
                <div className="popupInner">
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={onClickClose} />
                    <div className="popupInnerText" >
                        <h4 className="popupInnerFacility" >
                            {state.popupTitle}
                        </h4>
                    </div>
                    {isMobilePhone ?
                        (<Calendar
                            activeStartDate={activeStartDate}
                            locale={"ja-JP"}
                            calendarType={"US"}
                            maxDate={maxDate.current}
                            minDate={minDate.current}
                            value={null}
                            showDoubleView={false}
                            onClickDay={(val, event) => onClickTargetDay(val, event)}
                            formatDay={(locale, date) => date.getDate()}
                            tileClassName={({ activeStartDate, date, view }) => getbackGroundColor(activeStartDate, date, view)}
                            formatMonthYear={(locale, date) => layoutChangeOfMonthMobile(date)}
                            nextLabel={""}
                            prevLabel={""}
                            next2Label={null}
                            prev2Label={null}
                            tileContent={getTileContent}
                        />
                        ) :
                        (<Calendar
                            activeStartDate={activeStartDate}
                            locale={"ja-JP"}
                            calendarType={"US"}
                            maxDate={maxDate.current}
                            minDate={minDate.current}
                            value={null}
                            showDoubleView={false}
                            onClickDay={(val, event) => onClickTargetDay(val, event)}
                            formatDay={(locale, date) => date.getDate()}
                            tileClassName={({ activeStartDate, date, view }) => getbackGroundColor(activeStartDate, date, view)}
                            formatMonthYear={(locale, date) => layoutChangeOfMonthMobile(date)}
                            nextLabel={""}
                            prevLabel={""}
                            next2Label={null}
                            prev2Label={null}
                            tileContent={getTileContent}
                        />
                        )}
                    <div style={isMobilePhone ? style.descriptionAreaMobile : style.descriptionArea}>
                        <div style={isMobilePhone ? { textAlign: "left", display: "flex", marginTop: "6rem", marginLeft: "10px", flexWrap: "wrap", whiteSpace: "nowrap" }
                            : { textAlign: "left", display: "flex", marginTop: "1rem", marginLeft: "10px", whiteSpace: "nowrap" }}>
                            <div style={style.tableImageStyle}>
                                <Image image={circle} style={isMobilePhone ? style.imageStyleMobile : style.imageStyle} />
                                <Label label={":空室あり"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                            </div>
                            <div style={style.tableImageStyle} >
                                <Image image={triangle} style={isMobilePhone ? style.imageStyleMobile : style.imageStyle} />
                                <Label label={":残りわずか"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                            </div>
                            {/* <div style={style.tableImageStyle} >
                                <Image image={square} style={isMobilePhone ? style.imageStyleMobile : style.imageStyle} />
                                <Label label={":交換・キャンセル待ち"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                            </div> */}
                            <div style={style.tableImageStyle} >
                                <Image image={cross} style={isMobilePhone ? style.imageStyleMobile : style.imageStyle} />
                                <Label label={":満室"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                            </div>
                            <div style={style.tableImageStyle} >
                                <Image image={minus} style={isMobilePhone ? style.imageStyleMobile : style.imageStyle} />
                                <Label label={":クローズ"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                            </div>
                            {/* <div style={style.tableImageStyle} >
                                <Image image={slash} style={isMobilePhone ? style.imageStyleMobile : style.imageStyle} />
                                <Label label={":予約受付対象外"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                            </div>
                            <div style={style.tableImageStyle} >
                                <Label label={"占"} />
                                <Label label={":占有日"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                            </div> */}
                        </div>
                        <div style={{ textAlign: "left", marginLeft: "10px", color: "rgb(173, 173, 173)" }}>
                            <Label label={"※本日・明日・明後日のご予約はお電話にてご連絡ください"} style={isMobilePhone ? style.usageGuideMobile : style.usageGuide} />
                        </div>
                        {/* <div style={isMobilePhone ? { textAlign: "left", display: "block", marginLeft: "10px" }
                            : { textAlign: "left", display: "flex", marginLeft: "10px" }}>
                            <Label label={"※カレンダーと同じ色以上の消化権利を使用できます"} style={isMobilePhone ? style.rightGuideMobile : style.rightGuide} />
                            <div style={{ display: "flex" }}>
                                <div style={style.tableImageStyle}>
                                    <PrivilegeIcon className="gold" />
                                    <Label label={":ゴールド"} style={isMobilePhone ? style.usageGuideColorMobile : style.usageGuideColor} />
                                </div>
                                <div style={style.tableImageStyle} >
                                    <PrivilegeIcon className="red" />
                                    <Label label={":レッド"} style={isMobilePhone ? style.usageGuideColorMobile : style.usageGuideColor} />
                                </div>
                                <div style={style.tableImageStyle} >
                                    <PrivilegeIcon className="white" />
                                    <Label label={":ホワイト"} style={isMobilePhone ? style.usageGuideColorMobile : style.usageGuideColor} />
                                </div>
                                <div style={style.tableImageStyle} >
                                    <PrivilegeIcon className="blue" />
                                    <Label label={":ブルー"} style={isMobilePhone ? style.usageGuideColorMobile : style.usageGuideColor} />
                                </div>
                            </div>
                        </div> */}
                    </div>
                    {/* <div style={isMobilePhone ? style.buttonAreaMobile : style.buttonArea}>
                        <button id="calendarDecision" className="selectBtn" onClick={decision}>決定</button>
                    </div> */}
                </div>
                <div className="blackBackground" id="js-black-bg"></div>
            </div >
            <div className={latestFlg ? "membership_latest3Popup" : "popup"} id="js-popup">
                <div className="membership_latest3PopupInner">
                    <Label label={messageConst.WITHIN_3_DATE_MESSAGE} className="latest3Label" />
                    <Label label={facilityTel} className="latest3TelLabel" />
                    <button id="calendarDecision" className="closeLatestModalBtn" onClick={closeLatestModal}>閉じる</button>
                </div>
                <div className="membership_latest3PopupblackBackground" id="js-black-bg"></div>
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        room: state.room,
        resvKaiinken: state.resvKaiinken,
        vacancyItems: state.vacancyItems,
        grade: state.grade,
        membershipFacility: state.membershipFacility,
        adultNum: state.adultNum,
        childNum: state.childNum,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setMembershipFacility: (item) => {
            dispatch({ type: "MEMBERSHIP_FACILITY", payload: { membershipFacility: item } })
        },
        setDispFacility: (item) => {
            dispatch({ type: "DISP_FACILITY", payload: { dispFacility: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setCheckOut: (item) => {
            dispatch({ type: "CHECKOUT", payload: { checkOut: item } })
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(FacilityVacancyCalendarContainer);

const style = {
    svg: {
        height: "20",
        width: "20",
    },
    blackBackground: {
        position: "absolute",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, .8)",
        zIndex: "1",
    },
    buttonArea: {
        width: "100%",
        textAlign: "center",
        borderTop: "solid 1px #dddddd",
        padding: "15px 0 40px 0",
    },
    buttonAreaMobile: {
        width: "100%",
        textAlign: "center",
        borderTop: "solid 1px #dddddd",
        padding: "15x 0 15px 0",
    },
    descriptionArea: {
        width: "90%",
        textAlign: "center",
        padding: "10px 5% 10px 5%",
    },
    descriptionAreaMobile: {
        width: "100%",
        textAlign: "center",
        padding: "0 0 0 0",
    },
    button: {
        color: "#fff",
        backgroundColor: "#000",
        border: "solid 1px #000",
        padding: "15px 120px 15px 120px",
        cursor: "pointer",
    },
    tableImageStyle: {
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
    },

    imageStyle: {
        width: "11px",
        margin: "auto",
    },
    imageStyleMobile: {
        width: "11px",
        margin: "auto",
    },
    usageGuide: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 1rem 0.5rem 0.2rem",
    },
    usageGuideMobile: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 0.5rem 0.5rem 0.2rem",
    },
    usageGuideColor: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 1rem 0.5rem 0",
    },
    usageGuideColorMobile: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 0.5rem 0.5rem 0",
    },
    rightGuide: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 1rem 0.5rem 0.2rem",
        color: "rgb(173, 173, 173)",
    },
    rightGuideMobile: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 0.5rem 0rem 0.2rem",
        color: "rgb(173, 173, 173)",
    },
    circle: {
        backgroundImage: `url(${circle})`,
        height: 10,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        cursor: "pointer",
        padding: "10px 0px 0px 0px",
    },
    triangle: {
        backgroundImage: `url(${triangle})`,
        height: 10,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        cursor: "pointer",
    },
    square: {
        backgroundImage: `url(${square})`,
        height: 10,
        width: 13,
        margin: "0 auto",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        cursor: "pointer",
    },
    cross: {
        backgroundImage: `url(${cross})`,
        height: 10,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        opacity: "0.5",
    },
    minus: {
        backgroundImage: `url(${minus})`,
        height: 10,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        opacity: "0.5",
    },
    slash: {
        backgroundImage: `url(${slash})`,
        height: 10,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        border: "0px",
        display: "block",
        opacity: "0.5",
    },
    occupy: {
        height: "auto",
        border: "0px",
        display: "block",
        color: "black",
        fontSize: "10px",
    },
}
